import { Button, CircularProgress, FormHelperText, TextField, Container, Typography, Menu, MenuItem, IconButton, Tooltip, ClickAwayListener, Grid } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import NewNavBar from '../../components/NewNavBar';
import blurryImage from '../../assets/blurry.svg'
import chat from '../../assets/employee-chat.png'
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import { useState } from 'react';
import ArrowForwardIosNewIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import roboSmall from '../../assets/robo-small.svg'


const theme = createTheme({
    palette: {
        info:{
            main:'#5D4682',
            dark:'#4c396b'  
        }
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 800,
        md: 870,
        lg: 1200,
        xl: 1920,
      },
    },
    typography: {
        fontFamily: [
          'Inter', 
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          'sans-serif'
        ].join(',')
      }
  });


const useStyles=makeStyles(()=>({

    '@keyframes fadeInAnimation': {
        '0%': {
            opacity: 0,
        },
        '100%': {
            opacity: 1,
        },
    },
    pageRoot:{
        padding:'50px 0',
    },
    heading:{
        fontWeight:'500',
        fontSize:'40px',
        opacity: 0,
        animation: '$fadeInAnimation 1s ease-in forwards',
        '@media (max-width: 540px)': {
            fontSize:'30px',    
          },
    },
    firstContainer:{
        marginBottom:'50px',
    },
    example:{
      height:'auto',
      borderRadius:'30px',
      background: 'rgba(4, 10, 20, 0.6)',
      backdropFilter: 'saturate(1.5) blur(30px)',
      padding:'30px',
      minHeight:'140px',
    },
    secondContainer:{
        height:'auto',
        alignItems:'center',
        borderRadius:'30px',
        background: 'rgba(4, 10, 20, 0.6)',
        backdropFilter: 'saturate(1.5) blur(30px)',
        padding:'40px 10px',
        marginBottom:'50px',
    },
    upperGrid:{
        '@media (max-width: 870px)': {
            marginBottom:'35px',    
          },
    },
    textDiv:{
        fontSize:'18px',
        padding:'0 30px',
        
    },
    imageContainer:{
        
    },
    image:{
        width:'100%', 
        minWidth:'320px',
        maxWidth:'600px', 
        borderRadius:'20px',
    },
    bothDivs:{
      animation: '$fadeInAnimation 0.4s ease-in backwards',
      minHeight:'400px'
    },
}))

export default function EmployeeUseCase(){
    const classes=useStyles()
    const [benefitShown, setBenefitShown]=useState(true)

    const toggleTabs=(event: React.MouseEvent<HTMLButtonElement>)=>{
      event.preventDefault()
      setBenefitShown(!benefitShown)
    }

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth={"xl"} sx={{backgroundImage:`url(${blurryImage})`, backgroundSize:'cover', backgroundPosition:'center', padding:0}}>
                <NewNavBar/>
            <Container maxWidth={"xl"} className={classes.pageRoot} >
                <Container sx={{textAlign:'center', marginBottom:'50px'}}>
                    <Typography className={classes.heading}>Master your domain 3x faster than your colleagues</Typography>
                </Container>
                <Container>
                    <Grid container spacing={2} className={classes.firstContainer}>
                        <Grid item xs={12} md={6}>
                          <div className={classes.example}>
                            <Typography style={{fontWeight:'300'}}>In a complex domain? Dump your documents and let Learnly create tailored courses from your data. Master any topic using byte sized learning approach</Typography>
                          </div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <div className={classes.example}>
                            <Typography style={{fontWeight:'300'}}>Dump your documents, interact with your personal Guru to become one and let Learnly create tailored courses from your data. Master any topic using a byte sized learning approach. </Typography>
                          </div>
                        </Grid> 
                    </Grid>  
                </Container>
                <Container>
                    <Grid container className={classes.secondContainer}>
                        <Grid item xs={12} md={7} sx={{textAlign:'center'}} className={classes.upperGrid}>
                            <div className={classes.imageContainer}>
                                <img src={chat} className={classes.image} loading='lazy'/>
                            </div>
                        </Grid>  
                        <Grid item xs={12} md={5} style={{display:'flex',justifyContent:'center'}}>
                            <div className={classes.textDiv}>
                                    <div hidden={!benefitShown} className={`${classes.bothDivs}`}>
                                      <Typography style={{marginBottom:'35px', fontWeight:'400', fontSize:'25px'}}>Key Benefits <AutoGraphIcon/></Typography>
                                      <CustomRomanList text='Personalized Guru to interact and learn from'/>
                                      <CustomRomanList text='Create on-demand courses for any topic (you can provide your own training material), master it 3x faster than traditional learning methods'/>
                                      <CustomRomanList text='Increase retention with automated assessments'/>
                                      <CustomRomanList text='Increase productivity by reducing time to search and learn topics'/>
                                    </div>
                                    <div  hidden={benefitShown} className={`${classes.bothDivs}`}>
                                      <Typography style={{marginBottom:'35px', fontWeight:'400', fontSize:'25px'}}>Features <AutoAwesomeIcon/></Typography>
                                      <CustomRomanList text='Chat with virtual chatbots, trained on your custom material'/>
                                      <CustomRomanList text='Create courses in 1 click, based on the data you provided and more'/>
                                      <CustomRomanList text='Ensure learning with automatic assessments'/>
                                      <CustomRomanList text='Completely secure, your data is encrypted at rest, only accessible by you'/>
                                    </div>
                            </div>
                        </Grid>
                    </Grid>  
                </Container>
                <Container>
                    <Grid container className={classes.secondContainer}>     
                        <Grid item xs={12} md={5} style={{display:'flex',justifyContent:'center'}}>
                            <div className={classes.textDiv}>
                                    <div className={`${classes.bothDivs}`}>
                                      <Typography style={{marginBottom:'35px', fontWeight:'400', fontSize:'25px'}}>Features <AutoAwesomeIcon/></Typography>
                                      <CustomRomanList text='Chat with virtual chatbots, trained on your custom material'/>
                                      <CustomRomanList text='Create courses in 1 click, based on the data you provided and more'/>
                                      <CustomRomanList text='Ensure learning with automatic assessments'/>
                                      <CustomRomanList text='Completely secure, your data is encrypted at rest, only accessible by you'/>
                                    </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} md={7} sx={{textAlign:'center'}} className={classes.upperGrid}>
                            <div className={classes.imageContainer}>
                                <img src={roboSmall} className={classes.image} style={{width:'60%'}} loading='lazy'/>
                            </div>
                        </Grid> 
                    </Grid>  
                </Container>
            </Container>
            </Container>
        </ThemeProvider>
    )
}


function CustomRomanList({text}:{ text: string }){
    return(
        <Typography style={{marginBottom:'28px', lineHeight:'20px', fontWeight:'300'}}>
            {text}
        </Typography>
    )
}